import DataTable from '@core/Components/Util/DataTable/DataTable.vue';

import { cleanTooltips } from '@core/Util/Mixins/tooltips';
import resourceMixin from '@core/Util/Mixins/resources';

import status from '@modules/AudienceManager/Util/audience-status';

export default {
    mixins: [resourceMixin, cleanTooltips],
    components: {
        DataTable
    },
    beforeDestroy(){
        //Tooltips only disappear after a 'mouseleave' event is triggered
        //after our element is removed from the DOM by Vue, it will become impossible to trigger this event
        //therefor we need to manually clean upon component destruction to prevent lingering tooltips
        this.cleanTooltips();
    },
    computed: {
        status() {
            return status;
        }
    },
    props: {
        columns: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            loading: false
        }
    }
};